import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SortCoordinationService {
    private clearSortSubject = new Subject<string>();
    clearSort$ = this.clearSortSubject.asObservable();

    clearSortForTable(tableId: string) {
        this.clearSortSubject.next(tableId);
    }
}
